
















import { defineComponent, Ref, ref } from '@vue/composition-api';
import { useSeasonsDay }             from '@/views/seasons/hooks/use-seasons-day';
import { SeasonDate }                from '@/views/seasons/seasons.types';

export default defineComponent({
  name: 'cSeasonsDay',
  props: {
    month: {
      required: true,
      type: Number,
    },
    day: {
      required: true,
      type: Number,
    },
  },
  setup(props) {
    const seasonDay: Ref<HTMLElement | null> = ref(null);

    const {
      selection,
      updateSelection,
      getActiveDay,
      getClasses,
      getLabel,
      getSelectionClasses,
      getParentClass,
      getDatesBasedOnRange,
      updateCalendar,
    } = useSeasonsDay(props, seasonDay);

    const handleSelection = (): void => {
      if (selection.value.start && selection.value.end && selection.value.seasonCode) {
        let dates: SeasonDate[] = [];

        if (selection.value.start.month >= selection.value.end.month
          && selection.value.start.day > selection.value.end.day) {
          dates = getDatesBasedOnRange(selection.value.end, selection.value.start);
        } else {
          dates = getDatesBasedOnRange(selection.value.start, selection.value.end);
        }

        dates.forEach((date) => {
          updateCalendar({
            month: date.month,
            day: date.day,
            code: selection.value.seasonCode as string,
          });
        });
      }
    };

    const updateSelectionEnd = (day: number, month: number): void => {
      if (selection.value.seasonCode && selection.value.start) {
        updateSelection({
          end: {
            day,
            month,
          },
        });
      }
    };

    const deleteSelectionEnd = (): void => {
      if (selection.value.seasonCode) {
        updateSelection({
          end: null,
        });
      }
    };

    const setSeasonRange = (day: number, month: number): void => {
      if (selection.value.seasonCode) {
        if (!selection.value.start) {
          updateSelection({
            start: {
              day,
              month,
            },
          });
        } else {
          if (!selection.value.end) {
            updateSelection({
              end: {
                day,
                month,
              },
            });
          }

          handleSelection();
          updateSelection({
            end: null,
            start: null,
          });
        }
      }
    };

    return {
      seasonDay,
      setSeasonRange,
      updateSelectionEnd,
      deleteSelectionEnd,
      getActiveDay,
      getLabel,
      getClasses,
      getParentClass,
      getSelectionClasses,
    };
  },
});

